import { QueryClient } from '@tanstack/react-query';

// Single app-wide server-state cache. Defaults chosen to match the app's prior
// hand-rolled fetching semantics while adding cache/dedup:
//   - staleTime 30s: a short freshness window so reopening a screen within it is
//     instant with no background refetch (no loading flash), while data older
//     than 30s revalidates on reopen — keeping admin/support lists fresh.
//   - retry false: the old hooks did a single attempt and surfaced errors
//     immediately; do not silently retry idempotent reads.
// Hooks expose `loading: query.isFetching` so a manual Refresh reflects any
// in-flight fetch (not just the first load).
// The query defaults, exported so the test harness (createQueryWrapper) can run on
// the same freshness semantics as production instead of its own — a staleTime-0
// harness masks stale-read bugs that only surface under the app's 30s window.
export const queryDefaults = {
  staleTime: 30_000,
  gcTime: 5 * 60_000,
  refetchOnWindowFocus: false,
  retry: false,
} as const;

export const queryClient = new QueryClient({
  defaultOptions: { queries: queryDefaults },
});
